var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsBackgroundPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 211,
    viewBox: "0 0 375 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 2,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 34,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 66,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 98,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 130,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 162,
    r: 2,
    fill: "#7CCBC7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 194,
    r: 2,
    fill: "#7CCBC7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsBackgroundPlaceholder);
export default __webpack_public_path__ + "static/media/dots_background_placeholder.dcfef236f014b3abdd939a8f2c474818.svg";
export { ForwardRef as ReactComponent };